import { Inject, Injectable, InjectionToken } from '@angular/core';

export const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
    providedIn: 'root',
    factory: () => localStorage,
});


@Injectable()
export class BrowserStorageService {
    constructor(@Inject(BROWSER_STORAGE) public storage: Storage) {}

    get(key: string) {
        return this.storage.getItem(key);
    }

    set(key: string, value: any) {
        const object = JSON.stringify(value);
        this.storage.setItem(key, object);
    }

    remove(key: string) {
        this.storage.removeItem(key);
    }

    hasObject(key: string): boolean {
        return this.storage.getItem(key) !== null;
    }

    clear() {
        this.storage.clear();
    }
}
